import React from "react";
import routes from "routes.js";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Loading from "components/loading/Loading";
import axiosClient from "axios-client.js";
import Card from "components/card";
import { useStateContext } from "context/ContextProvider.jsx";
import Table from "components/Table";

// let pageCacheTimeout;

const MyCustomTable = ({ columns, endpoint, title, description }) => {
    const [tableData, setTableData] = useState([]);
    const [pages, setPages] = useState({});
    const { searchValue } = useStateContext();
    const [load, setLoad] = useState(false);
    const [message, setMessage] = useState({});

    const [isFetching, setIsFetching] = useState(false);
    const [filters, setFilters] = useState({ page: 1 });
    const [maxPages, setMaxPages] = useState();
    const [totalElements, setTotalElements] = useState();
    const [pageSize, setPageSize] = useState(10);
    const [orderBy, setOrderBy] = useState([]);

    const newActivationRoute =
        routes.find(({ path }) => path === "new-activation") ?? "";

    const fetchNewData = () => {
        setLoad(true);
        setMessage({});
        axiosClient
            .get(endpoint, {
                params: {
                    filter: searchValue,
                    page: filters.page,
                    per_page: pageSize,
                    // order_by:
                    //     orderBy?.at(0) && orderBy?.at(0)?.id
                    //         ? orderBy?.at(0)?.id
                    //         : "",
                    // order_direction:
                    //     orderBy?.at(0) && orderBy?.at(0)?.id
                    //         ? orderBy?.at(0)?.desc
                    //             ? "desc"
                    //             : "asc"
                    //         : "",
                },
            })
            .then(({ data }) => {
                setLoad(false);
                setTableData(data.data.data);
                // setPages((prev) => {
                //     prev[`${searchValue}${filters.page}${pageSize}${orderBy}`] =
                //         data.data.data;
                //     return prev;
                // });
                // clearTimeout(pageCacheTimeout);
                // pageCacheTimeout = setTimeout(() => {
                //     setPages({});
                // }, 60000);
                setTotalElements(data.data.total);
                setMaxPages(
                    data.data.total % data.data.per_page === 0
                        ? data.data.total / data.data.per_page
                        : Math.floor(data.data.total / data.data.per_page) + 1
                );
            })
            .catch((err) => {
                const response = err.response;
                setLoad(false);
                if (response) {
                    setMessage({
                        text: response.data.message,
                        type: "ERROR",
                        errors: response.data.errors
                            ? response.data.errors
                            : {},
                    });
                }
            });
    };

    useEffect(() => {
        fetchNewData();
    }, [filters, pageSize, searchValue]);

    return (
        <div>
            {load ? <Loading /> : null}
            <div className="mt-5 grid h-full grid-cols-1 gap-5">
                <Card extra={"w-full h-full p-4 overflow-x-none"}>
                    <div className="overflow-x-none h-full">
                        {message.hasOwnProperty("text") ? (
                            <div
                                className={
                                    "mb-6 text-left text-base " +
                                    (message.type === "SUCCESS"
                                        ? "text-green-500"
                                        : message.type === "ERROR"
                                        ? "text-red-500"
                                        : message.type === "WARNING"
                                        ? "text-amber-500"
                                        : null)
                                }
                            >
                                <p>{message.text}</p>
                            </div>
                        ) : null}
                        {tableData?.length > 0 ? (
                            <Table
                                data={tableData}
                                filters={filters}
                                setFilters={setFilters}
                                fetching={isFetching}
                                columns={columns}
                                pageSize={pageSize}
                                setPageSize={setPageSize}
                                maxPages={maxPages}
                                orderBy={orderBy}
                                setOrderBy={setOrderBy}
                                pages={true}
                                isFetching={isFetching}
                                totalElements={totalElements}
                                showPageSize={true}
                                title={title}
                                description={description}
                                bodyMaxHeight={""}
                                scroll={false}
                                showGoToPage={true}
                                reload={undefined}
                            />
                        ) : (
                            <div className="flex flex-col items-center gap-2">
                                <p className="flex w-full justify-center border-b border-gray-50 py-3">
                                    Nessun dato disponibile
                                </p>

                                <div className="py-3">
                                    <Link
                                        to={
                                            newActivationRoute.layout +
                                            "/" +
                                            newActivationRoute.path
                                        }
                                    >
                                        <button className="linear rounded-[8px] bg-brand-500 px-[20px] py-[12px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200">
                                            Nuova attivazione
                                        </button>
                                    </Link>
                                </div>
                            </div>
                        )}
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default MyCustomTable;
